module.exports = __webpack_public_path__ + "img/card_shadow_top_left.8ca2b342.svg";